import { toast } from "react-toastify";

import {
  fetchDeleteOfferStart,
  fetchDeleteOfferSuccess,
  fetchDeleteOfferFailure,
} from "./reducer";

import { DELETE_PARTNER_OFFER } from "../../constants/constants";

import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";

export const deletePartnerOffer =
  (offerId, setLoading, onSuccess) =>
  async (dispatch) => {
    dispatch(fetchDeleteOfferStart());

    setLoading?.(true);

    try {
      const response =
        await determineBaseUrlAndPerformApiCall(
          DELETE_PARTNER_OFFER(offerId),
          "DELETE"
        );

      if (response?.error) {
        dispatch(
          fetchDeleteOfferFailure(
            response.error.message || "Failed to delete offer"
          )
        );

        toast.error(
          response.error.message || "Failed to delete offer"
        );

        return;
      }

      dispatch(fetchDeleteOfferSuccess(response));

      toast.success(
        response?.message || "Offer deleted successfully"
      );

      if (onSuccess) {
        onSuccess(response);
      }
    } catch (error) {
      const errorMessage =
        error?.message || "Something went wrong";

      dispatch(fetchDeleteOfferFailure(errorMessage));

      toast.error(errorMessage);
    } finally {
      setLoading?.(false);
    }
  };